export const size = {
    xxs: "600px",
    xs: "768px",
    sm: "1023px",
    md: "1280px",
    lg: "1400px",
    xl: "1920px",
};

export const breakpoints = {
    xxs: `(max-width: ${size.xxs})`,
    xs: `(max-width: ${size.xs})`,
    sm: `(max-width: ${size.sm})`,
    mdMax: `(max-width: ${size.md})`,
    md: `(min-width: ${size.md})`,
    lg: `(min-width: ${size.lg})`,
    xl: `(min-width: ${size.xl})`,
    xxsMin: `(min-width: ${size.xxs})`,
    xsMin: `(min-width: ${size.xs})`,
    smMin: `(min-width: ${size.sm})`,
};
